import { useCallback } from "react";
import { useProjectContext } from "~/pages/Project/context";
import { useCreateTaskContext } from "./context";

export const useCreateTask = () => {
  const { projectId } = useProjectContext();
  const { openModal } = useCreateTaskContext();

  const openTaskForm = useCallback(
    (presetNoAssignee = false, assigneeId = 0) => {
      typeof openModal === "function" && openModal({ projectId, assigneeId, presetNoAssignee });
    },
    [openModal, projectId]
  );

  return { openTaskForm };
};
